
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/session",
      function () {
        return require("private-next-pages/tools/session.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/session"])
      });
    }
  